'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _formBridgeMaster = require('../common/form-bridge-master');

var _formBridgeMaster2 = _interopRequireDefault(_formBridgeMaster);

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var PARAM_FIELD_ID_LIST = ['system.detail', 'system.correction'];
var IframeField = (_temp = _class = function (_Field) {
  _inherits(IframeField, _Field);

  function IframeField(props) {
    _classCallCheck(this, IframeField);

    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    var fieldId = props.fieldId;

    _this.containerId = 'iframe-container-' + fieldId;
    _this.bridgeMaster = new _formBridgeMaster2.default({ key: fieldId });
    // this.bridgeMaster = new FormBridgeMaster();
    _this.iframeContainer = _react2.default.createRef(null);
    return _this;
  }

  IframeField.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        url = _props.url,
        initialParams = _props.initialParams,
        runtimeParams = _props.runtimeParams,
        onChange = _props.onChange;

    var behavior = this.getBehavior();
    var detail = behavior === 'READONLY';
    this.bridgeMaster.openSlot(url, { containerId: this.containerId, detail: detail });

    this.bridgeMaster.onReady(function () {
      // 传递数据给组件
      _this2.bridgeMaster.onReceiveData(function (value) {
        onChange && onChange({ value: _this2.formatOut(value) });
      });

      _this2.bridgeMaster.onClientReady(function () {
        _this2.bridgeMaster.postData({
          initialParams: initialParams,
          runtimeParams: runtimeParams,
          processParams: _this2.getCurrentEnvStep(),
          detail: detail
        });
      });
    });
  };

  IframeField.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var runtimeParams = this.props.runtimeParams;

    var prevValue = this.formatIn((prevState.fieldData || {}).value);
    var value = this.getValue();
    var prevRuntimeParams = prevProps.runtimeParams;
    // 当 runtimeParams 或 value 发生变化时，将数据传递给 iframe 应用

    if (runtimeParams && JSON.stringify(runtimeParams) !== JSON.stringify(prevRuntimeParams) || JSON.stringify(value) !== JSON.stringify(prevValue)) {
      this.bridgeMaster.postData({
        runtimeParams: runtimeParams,
        value: value,
        processParams: this.getCurrentEnvStep()
      });
    }
  };

  IframeField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-iframe'
    });
  };
  /**
   * 获取表单处在受理流程的哪个环节
   * 详细见https://aone.alibaba-inc.com/v2/project/1061355/req/35558040
   * system.detail: 表示是否在详情页
   * system.correction: 表示是否在补齐补正环节
   * 对于后端传的这两个值，透传给iframe组件里的页面，不做额外信息加工
   */


  IframeField.prototype.getCurrentEnvStep = function getCurrentEnvStep() {
    var context = this.props.context;

    return PARAM_FIELD_ID_LIST.reduce(function (total, fieldId) {
      var filedElement = context.store.get(fieldId);

      if (!(0, _lodash.isNil)(filedElement)) {
        total[fieldId.replace('system.', '')] = filedElement.getVal();
      }

      return total;
    }, {});
  };

  IframeField.prototype.renderView = function renderView() {
    return this.renderControl();
  };

  IframeField.prototype.renderControl = function renderControl() {
    var _props2 = this.props,
        iframeHeight = _props2.iframeHeight,
        iframeWidth = _props2.iframeWidth;

    return _react2.default.createElement('div', {
      className: 'vc-iframe-container',
      id: this.containerId,
      style: { height: iframeHeight, width: iframeWidth }
    });
  };

  return IframeField;
}(_vuFusionField2.default), _class.displayName = 'Iframe', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  iframeHeight: '400px',
  iframeWidth: '100%'
}), _class.propTypes = {
  fieldId: _propTypes2.default.string,
  label: _propTypes2.default.string
}, _temp);
exports.default = IframeField;
module.exports = exports['default'];